(() => {
  const ELEMENT_NAME = 'subscription-landing';

  if (customElements.get(ELEMENT_NAME)) return;

  class SubscriptionLanding extends HTMLElement {
    connectedCallback() {
      this.dataset.motion = 'static';

      if (!window.gsap) return;

      const { gsap } = window;
      if (window.ScrollTrigger) {
        gsap.registerPlugin(window.ScrollTrigger);
      }

      this.motionMedia = gsap.matchMedia();
      this.motionMedia.add(
        {
          motionAllowed: '(prefers-reduced-motion: no-preference)',
          parallaxAllowed:
            '(min-width: 990px) and (hover: hover) and (prefers-reduced-motion: no-preference)',
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          if (context.conditions.reduceMotion) {
            this.dataset.motion = 'reduced';
            return;
          }

          const select = gsap.utils.selector(this);
          const foodPhoto = select('.nm-hero__food-photo')[0];
          const planArt = select('.nm-hero__plan-art')[0];
          const ticket = select('[data-nm-hero-ticket]')[0];
          const dayFills = select('[data-nm-hero-day] i');
          const dayLabels = select('[data-nm-hero-day] b');
          const status = select('[data-nm-status]')[0];
          const parallaxImages = select(
            '.nm-continuity__backdrop img, .nm-how__backdrop img, .nm-addons__backdrop img, .nm-payment__backdrop img, .nm-final__backdrop img'
          );
          const parallaxTweens = [];

          this.dataset.motion = 'ready';
          gsap.set(dayFills, { scaleY: 0, transformOrigin: 'bottom center' });

          const intro = gsap.timeline({
            defaults: {
              duration: 0.9,
              ease: 'expo.out',
            },
          });

          if (foodPhoto) {
            intro.fromTo(foodPhoto, { scale: 1.035 }, { scale: 1 }, 0);
          }

          if (planArt) {
            intro.fromTo(planArt, { y: 24 }, { y: 0 }, 0.08);
          }

          if (ticket) {
            intro.fromTo(ticket, { x: 34 }, { x: 0 }, 0.18);
          }

          if (dayFills.length) {
            intro.to(
              dayFills,
              {
                duration: 0.48,
                ease: 'power3.out',
                scaleY: 1,
                stagger: 0.08,
              },
              0.48
            );
          }

          if (dayLabels.length) {
            intro.to(
              dayLabels,
              {
                color: 'var(--nm-cream)',
                duration: 0.25,
                stagger: 0.08,
              },
              0.52
            );
          }

          if (status) {
            intro.fromTo(
              status,
              { opacity: 0.5 },
              { opacity: 1, duration: 0.35 },
              0.92
            );
          }

          intro.eventCallback('onComplete', () => {
            this.dataset.motion = 'complete';
          });

          if (context.conditions.parallaxAllowed && window.ScrollTrigger) {
            parallaxImages.forEach((image) => {
              const section = image.closest('section');
              if (!section) return;

              image.dataset.nmParallax = 'ready';
              parallaxTweens.push(
                gsap.fromTo(
                  image,
                  {
                    force3D: true,
                    scale: 1.1,
                    yPercent: -3.5,
                  },
                  {
                    ease: 'none',
                    force3D: true,
                    scale: 1.1,
                    scrollTrigger: {
                      end: 'bottom top',
                      invalidateOnRefresh: true,
                      scrub: 0.8,
                      start: 'top bottom',
                      trigger: section,
                    },
                    yPercent: 3.5,
                  }
                )
              );
            });
          }

          return () => {
            intro.kill();
            parallaxTweens.forEach((tween) => tween.kill());
            parallaxImages.forEach((image) => {
              delete image.dataset.nmParallax;
            });
          };
        },
        this
      );
    }

    disconnectedCallback() {
      this.motionMedia?.revert();
      this.motionMedia = null;
    }
  }

  customElements.define(ELEMENT_NAME, SubscriptionLanding);
})();
